


























import { Vue, Prop, Component } from 'vue-property-decorator';
import { EButtonTypes } from '@/enums/ButtonType';
import { ELoaderColor } from '@lib-ui/components/base-loader-circular/types/loader-color';

@Component
export default class Button extends Vue {
  @Prop({ default: false }) dense: boolean;
  @Prop({ default: false }) mobile: boolean;
  @Prop({ default: false }) disabled: boolean;
  @Prop({ default: false }) icon: boolean;
  @Prop({ default: false }) isLoading: boolean;
  @Prop({ default: false }) rounded: boolean;
  @Prop({ default: EButtonTypes.primary }) type: EButtonTypes;
  @Prop({ default: false }) centered: boolean;

  handleClick(e) {
    this.$emit('click', e);
  }

  get loaderColor() {
    return this.type === EButtonTypes.secondary ? ELoaderColor.Primary : ELoaderColor.Light;
  }
}
